/** Minimal company shape for payroll-automation DATEV eligibility checks. */
export type DatevPayrollSoftwareCompany =
  | {
      software?: string | null
    }
  | null
  | undefined

/**
 * True when the company's payroll software is DATEV LODAS (`company.software`).
 * This is the Abrechnungssoftware field on the companies doc, not
 * `company.datev.using` (FiBu export).
 */
export function isDatevPayrollSoftware(
  company: DatevPayrollSoftwareCompany
): boolean {
  return company?.software === 'datev-lodas'
}
